"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AssetInfo = require("./AssetInfo");
Object.keys(_AssetInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AssetInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AssetInfo[key];
    }
  });
});
var _GetDocumentPropsArgs = require("./GetDocumentPropsArgs");
Object.keys(_GetDocumentPropsArgs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetDocumentPropsArgs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GetDocumentPropsArgs[key];
    }
  });
});
var _GetLanguages = require("./GetLanguages");
Object.keys(_GetLanguages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetLanguages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GetLanguages[key];
    }
  });
});
var _LanguageDescriptor = require("./LanguageDescriptor");
Object.keys(_LanguageDescriptor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageDescriptor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageDescriptor[key];
    }
  });
});
var _OriDocument = require("./OriDocument");
Object.keys(_OriDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OriDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OriDocument[key];
    }
  });
});
var _OriDocumentContext = require("./OriDocumentContext");
Object.keys(_OriDocumentContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OriDocumentContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OriDocumentContext[key];
    }
  });
});
var _QueryParams = require("./QueryParams");
Object.keys(_QueryParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QueryParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QueryParams[key];
    }
  });
});
var _StaticAppContext = require("./StaticAppContext");
Object.keys(_StaticAppContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StaticAppContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StaticAppContext[key];
    }
  });
});
var _UserSegmentationQueryParams = require("./UserSegmentationQueryParams");
Object.keys(_UserSegmentationQueryParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserSegmentationQueryParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UserSegmentationQueryParams[key];
    }
  });
});
